// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box 
	SearchInput.prototype.customizeInstantSearch = function() {};

	SearchInput.prototype.afterBindEvents = function() {
		// Fix cannot close search suggestion when clicking overlay 
		document.addEventListener('click', function(e) {
			if(this.searchAutoComplete && this.searchAutoComplete.isOpen && e && e.target) {
				var $clickedElement = jQ(e.target);
				var isClickSuggestion = $clickedElement.closest('.' + Class.searchSuggestionWrapper).length > 0;
				if (isClickSuggestion) {
					this.searchAutoComplete.$element.hide();
					this.searchAutoComplete.searchInput.onCloseAutocomplete();
					this.searchAutoComplete.isOpen = false;
				}
			}
		}.bind(this), true);
	}
    
    InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
		// If the multi-currency feature is enabled, update the product price
        var priceDisplayMetafield = Utils.getProductMetafield(this.data , 'my_fields' , 'no_price_on_concept2');
        var priceShouldBeDisplayed = priceDisplayMetafield == null || priceDisplayMetafield === "false";
        if(!priceShouldBeDisplayed || this.data.template_suffix == 'BW-Product-new-3kit') return '';
		this.prepareSuggestionProductPriceData();
		// Check on sale
		var onSale = this.data.compare_at_price_min > this.data.price_min;
		// Format price
		var price = Utils.formatMoney(this.data.price_min);
		var compareAtPrice = '';
		if (this.data && this.data.compare_at_price_min) {
			compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
			if (Settings.getSettingValue('search.removePriceDecimal')) {
				price = Utils.removeDecimal(price);
				compareAtPrice = Utils.removeDecimal(compareAtPrice);
			}
		}
		// Build Price
		var result = '';
		if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
			if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
			} else {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
			}
		}
		return result
			.replace(/{{regularPrice}}/g, price)
			.replace(/{{compareAtPrice}}/g, compareAtPrice);
	}
    
    /* start-boost-custom */
    /* #boost-125756: customize instant search results */
    InstantSearchApi.beforeCall = function(searchTerm) {
        Globals.instantSearchQueryParams.country = Shopify.country;
      Globals.instantSearchQueryParams.currency = boostPFSConfig.general.current_currency.toLowerCase();
      Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate;
      Globals.instantSearchQueryParams.return_all_currency_fields = false;
      
        if (window.location.href.includes('https://ca')) {
          if (!Globals.instantSearchQueryParams.hasOwnProperty('tag') || Globals.instantSearchQueryParams.tag === null) {
            Globals.instantSearchQueryParams.tag = ['Canada'];
          } else {
            Globals.instantSearchQueryParams.tag.push('Canada');
          }
        }
    }
    /* end-boost-custom */
})();